import React, { useState } from 'react';
import '../css/BugReport.css';
import { FaBug, FaTimes, FaExclamationTriangle, FaEdit, FaSave } from "react-icons/fa";

const TICKET_TYPES = [
  { value: 'general', label: 'Általános hiba' },
  { value: 'notice', label: 'Észrevétel' },
  { value: 'other', label: 'Egyéb' },
];

const BugReportModal = ({ open, onClose, onSubmit }) => {
  const [subject, setSubject] = useState('');
  const [type, setType] = useState(TICKET_TYPES[0].value);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!subject.trim() || !message.trim()) {
      setError('Minden mező kitöltése kötelező!');
      return;
    }
    setError('');
    onSubmit({ subject, type, message });
    setSubject('');
    setType(TICKET_TYPES[0].value);
    setMessage('');
  };

  return (
    <div className="bug-modal-backdrop" onClick={onClose}>
      <div className="bug-modal" onClick={e => e.stopPropagation()}>
        <div className="bug-modal-header">
          <div className="bug-modal-title">
            <FaBug className="bug-modal-icon" />
            <h3>Új hibajegy létrehozása</h3>
          </div>
          <button className="bug-modal-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="bug-modal-content">
          <form onSubmit={handleSubmit} className="bug-modal-form">
            <div className="bug-modal-section">
              <label className="bug-modal-label">
                <FaEdit className="label-icon" />
                Tárgy *
              </label>
              <input
                className="bug-modal-input"
                value={subject}
                onChange={e => setSubject(e.target.value)}
                placeholder="Adja meg a hibajegy tárgyát..."
                required
              />
            </div>

            <div className="bug-modal-section">
              <label className="bug-modal-label">
                <FaExclamationTriangle className="label-icon" />
                Hibajegy típusa *
              </label>
              <select
                className="bug-modal-select"
                value={type}
                onChange={e => setType(e.target.value)}
                required
              >
                {TICKET_TYPES.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>

            <div className="bug-modal-section">
              <label className="bug-modal-label">
                <FaEdit className="label-icon" />
                Részletes leírás *
              </label>
              <textarea
                className="bug-modal-textarea"
                rows={4}
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder="Írja le részletesen a hibát vagy észrevételt..."
                required
              />
            </div>

            {error && (
              <div className="bug-modal-error">
                <FaExclamationTriangle />
                {error}
              </div>
            )}
          </form>
        </div>

        <div className="bug-modal-actions">
          <button className="bug-modal-cancel-btn" type="button" onClick={onClose}>
            <FaTimes />
            Mégse
          </button>
          <button
            className="bug-modal-save-btn"
            onClick={handleSubmit}
            disabled={!subject.trim() || !message.trim()}
          >
            <FaSave />
            Hibajegy létrehozása
          </button>
        </div>
      </div>
    </div>
  );
};

export default BugReportModal; 